/*! *********************************************************************
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { ASSET_STATUS, ASSET_TYPE } from '../../models/asset';

const validateAsset = (values) => {
  const errors = {};

  // requirements
  if (!values.title) {
    errors.title = 'The title is required';
  }

  if (!values.type) {
    errors.type = 'The type is required';
  }

  if (!values.status) {
    errors.status = 'The status is required';
  }

  if (!values?.extraData?.author) {
    errors.extraData = {
      ...errors.extraData,
      author: 'The author is required',
    };
  }

  // Specific
  if (
    [ASSET_TYPE.MATERIAL, ASSET_TYPE.ATLAS, ASSET_TYPE.DECAL].indexOf(
      values.type,
    ) !== -1
  ) {
    if (!values?.extraData?.physicalSize)
      errors.extraData = {
        ...errors.extraData,
        physicalSize: 'The physical size is required for this type of asset',
      };
    if (!values?.extraData?.type)
      errors.extraData = {
        ...errors.extraData,
        type: 'The asset generation type is required',
      };
  }

  // PUBLISH STATUS
  if (values.status === ASSET_STATUS.PUBLISHED) {
    if (values.categories.length === 0) {
      errors.categories = 'The categories is required';
    } else if (values.categories.length > 1) {
      errors.categories = '1 category max';
    }

    if (values.tags.length < 1) {
      errors.tags = 'Tags are required';
    } else {
      values.tags.forEach((t) => {
        if (t.length < 1)
          errors.tags = 'Each tags should be at least 1 char long';
      });
    }

    if (values.thumbnail.tags.indexOf('placeholder') !== -1) {
      errors.previews = 'The thumbnail is required and cannot be a placeholder';
    }
  }

  return errors;
};

export default validateAsset;
